import React from 'react'

import { makeRequest, useRequest } from "_utils/request";
import { fromApi, ItemDownload } from "../_types/item";

import { ItemEntry } from "./ItemEntry";
import { Loader } from '_components';
import { Alert } from "../_components/Alert";

import './ItemList.sass'

export const ItemList: React.FC = () => {
  const request = makeRequest("/instruments", "GET")
  const [response] = useRequest<[ItemDownload]>(request);
  switch (response.kind) {
    case "success":
      return <div className='items'>
        {response.payload.map(item => fromApi(item)).map(item => (<ItemEntry key={item.uuid} item={item} />))}
      </div>
    case "error":
      return <Alert contextualClass="warning">Problem loading instrument list. Please try again later.</Alert>
    default:
      return <Loader />
  }
}
